import service from '../request/index'

const baseUrl = window.globalUrl.HOME_API;

// 查询所有绘制地块资源资产的空间信息
export const findPgLandList = () => {
    return service({
        url: `${baseUrl}/trade-website/pg-resource-assets/findList`,
        method: 'get',
    })
}

// 查询所有绘制地块资源资产的空间信息
export const findPgOrderList = () => {
    return service({
        url: `${baseUrl}/trade-website/pg-order-assets/findList`,
        method: 'get',
    })
}